import axios from 'axios'

export default {
  getConnections(params) {
    return axios.get(`/hotspots/conexoes/${params.identity}`, {
      params
    })
  },
  getRanking(params) {
    return axios.get(`/hotspots/ranking-conexoes/${params.identity}`, {
      params
    })
  }

}
